module.exports = __webpack_public_path__ + "media/images/emblems/Gondiswil-coat_of_arms-818a3c88e0b05606d37f057287dcb97f.svg";